import React, { Component } from 'react';
import Dropdown from 'react-dropdown'
import {FASTEST_UPDATE_RATE,
        FAST_UPDATE_RATE,
        MID_UPDATE_RATE,
        SLOW_UPDATE_RATE,
        SLOWEST_UPDATE_RATE} from 'constants/eq8-update-rates.js';

class EQ8UpdateRateDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getOption(value) {
        return OPTIONS.filter(
            o => o.value === value)[0];
    }

    onSelectOption(option) {
        this.props.onUpdateRateChanged(option.value);
    }

    render() {
        return (
            <div></div>
        );
        /*
        return (
            <div className="osc-type-dropdown-container">
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={OPTIONS}
                  onChange={(o) => this.onSelectOption(o)}
                  value={this.getOption(this.props.updateRate)}
                  placeholder="LFO" />
              </div>
        );
        */
    }
}

const OPTIONS = [
    {value: FASTEST_UPDATE_RATE, label: 'Fastest'},
    {value: FAST_UPDATE_RATE, label: 'Fast'},
    {value: MID_UPDATE_RATE, label: 'Medium'},
    {value: SLOW_UPDATE_RATE, label: 'Slow'},
    {value: SLOWEST_UPDATE_RATE, label: 'Slowest'},
];

export default EQ8UpdateRateDropdown;
